export enum TransactionSelectItemsEnum {
  ALL = 'All',
  ADD = 'Add',
  REMOVE = 'Remove',
  SWAP_1_TO_2 = 'Swap XTZ to token',
  SWAP_2_TO_1 = 'Swap token to XTZ',
}

export type TranscationsSelectItemsType = {
  id: number
  type: TransactionSelectItemsEnum
};

export const items = [
  {
    id: 1,
    type: TransactionSelectItemsEnum.ALL,
  },
  {
    id: 2,
    type: TransactionSelectItemsEnum.ADD,
  },
  {
    id: 3,
    type: TransactionSelectItemsEnum.SWAP_1_TO_2,
  },
  {
    id: 4,
    type: TransactionSelectItemsEnum.SWAP_2_TO_1,
  },
  {
    id: 5,
    type: TransactionSelectItemsEnum.REMOVE,
  },
] as TranscationsSelectItemsType[];
